export default __webpack_public_path__ + "static/media/04_Prase_divoke_PELZ_upr.98f04710.mp3";